const Layout = () => import(/* webpackChunkName: "home" */ "../views/Layout.vue");
const Home = () => import(/* webpackChunkName: "home" */ "../views/home/Index.vue");
const BookRoom = () => import(/* webpackChunkName: "home" */ "../views/home/BookRoom.vue");
const PayResult = () => import(/* webpackChunkName: "home" */ "../views/home/PayResult.vue");
const RoomDetail = () => import(/* webpackChunkName: "home" */ "../views/home/RoomDetail.vue");
const OrderRoom = () => import(/* webpackChunkName: "home" */ "../views/home/OrderRoom.vue");
const AboutUs = () => import(/* webpackChunkName: "home" */ "../views/home/AboutUs.vue");
export default [
    {
        path: "/home",
        hidden: true,
        component: Layout,
        meta: {
            title: "首页",
            titleEn: "Home",
        },
        children: [
            {
                path: "",
                component: Home,
            },
            {
                path: "book-room",
                component: BookRoom,
            },
            {
                path: "pay-result",
                component: PayResult,
                meta: {
                    auth: true
                }
            },
            {
                path: "room-detail",
                component: RoomDetail,
            },
            {
                path: "order-room",
                component: OrderRoom,
                meta: {
                    auth: true
                }
            },
            {
                path: "about-us",
                component: AboutUs,
            },
        ],
    },
];
